import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getPartList = (code) =>
  apiActionCreator({
    'endpoint': `/parts/list?search=${code}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PRINT_PART_LIST,
      ActionTypes.FETCHED_PRINT_PART_LIST,
      [ActionTypes.FETCHED_PRINT_PART_LIST_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });


export const clearPrintPartList = () => ({
  'type': ActionTypes.CLEAR_PRINT_PART_LIST_FAILED,
});
  
